import { type ProductGearProps } from '@/components/sections/einstein/product/gear';

export const SHARED_PRODUCT_GEAR_DATA: ProductGearProps = {
  active: true,
  menu: {
    hash: '#transmission',
    label: 'ระบบส่งกำลัง',
  },
  bgImage: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt439d93d43be66dbd/672dbd21e9a3c67ed1f51e39/gear-bg-8.svg',
    alt: 'New! 8-Speed Rev Tronic',
    width: 487,
    height: 320,
  },
  logoImage: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt2483cfb5b261e4db/672dbd27a6bfe72fb19c03a5/logo-gear-8-speed.png',
    alt: 'New! 8-Speed Rev Tronic',
    width: 332,
    height: 104,
  },
  gearImage: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt827ad9d5f2f2041e/6737102e34cf2e56ca98da02/pickup-new-gear-8-speed.png',
    alt: 'New! 8-Speed Rev Tronic',
    width: 632,
    height: 474,
  },
  title: 'ใหม่! เกียร์อัตโนมัติ 8 สปีด <span>แบบ REV TRONIC</span>',
  description: `ออกแบบอัตราทดให้ส่งกำลังต่อเนื่อง <span>สัมพันธ์กับแรงบิด</span>ที่สูงตั้งแต่ช่วงออกตัว<span>และขณะเร่งแซง</span><span>ของเครื่องยนต์</span> <span>2.2 Ddi MAXFORCE</span>`,
};
